const bus = [
  {
    lat: 44.752007,
    lng: 41.82388
  }, { lat: 44.752712, lng: 41.823834 }, { lat: 44.753541, lng: 41.823778 }, {
    lat: 44.754172,
    lng: 41.823756
  }, { lat: 44.754456, lng: 41.823742 }, { lat: 44.754931, lng: 41.823726 }, {
    lat: 44.755396,
    lng: 41.823727
  }, { lat: 44.755807, lng: 41.823738 }, { lat: 44.756672, lng: 41.823798 }, {
    lat: 44.756826,
    lng: 41.823819
  }, { lat: 44.75695, lng: 41.823886 }, { lat: 44.757421, lng: 41.824226 }, {
    lat: 44.758214,
    lng: 41.824701
  }, { lat: 44.758417, lng: 41.824811 }, { lat: 44.75908, lng: 41.825211 }, {
    lat: 44.759098,
    lng: 41.825228
  }, { lat: 44.759107, lng: 41.825247 }, { lat: 44.759111, lng: 41.825269 }, {
    lat: 44.759111,
    lng: 41.825293
  }, { lat: 44.759106, lng: 41.825321 }, { lat: 44.75909, lng: 41.825348 }, {
    lat: 44.759061,
    lng: 41.825377
  }, { lat: 44.758524, lng: 41.825834 }, { lat: 44.758497, lng: 41.825861 }, {
    lat: 44.758485,
    lng: 41.825881
  }, { lat: 44.758481, lng: 41.825901 }, { lat: 44.758496, lng: 41.825925 }, {
    lat: 44.758514,
    lng: 41.825947
  }, { lat: 44.758541, lng: 41.825967 }, { lat: 44.758967, lng: 41.826232 }, {
    lat: 44.759808,
    lng: 41.826796
  }, { lat: 44.760649, lng: 41.827345 }, { lat: 44.760881, lng: 41.827495 }, {
    lat: 44.761041,
    lng: 41.827622
  }, { lat: 44.761205, lng: 41.827808 }, { lat: 44.761288, lng: 41.827893 }, {
    lat: 44.761322,
    lng: 41.827911
  }, { lat: 44.761363, lng: 41.827928 }, { lat: 44.761408, lng: 41.827942 }, {
    lat: 44.762389,
    lng: 41.828256
  }, { lat: 44.763189, lng: 41.828495 }, { lat: 44.76438, lng: 41.828827 }, {
    lat: 44.764477,
    lng: 41.828835
  }, { lat: 44.764696, lng: 41.828902 }, { lat: 44.764775, lng: 41.828931 }, {
    lat: 44.76555,
    lng: 41.829142
  }, { lat: 44.765782, lng: 41.829194 }, { lat: 44.766032, lng: 41.829229 }, {
    lat: 44.766188,
    lng: 41.829227
  }, { lat: 44.766326, lng: 41.829221 }, { lat: 44.766624, lng: 41.829179 }, {
    lat: 44.766951,
    lng: 41.829077
  }, { lat: 44.76761, lng: 41.828802 }, { lat: 44.7678, lng: 41.828726 }, {
    lat: 44.767868,
    lng: 41.82869
  }, { lat: 44.767961, lng: 41.828648 }, { lat: 44.768031, lng: 41.828603 }, {
    lat: 44.768107,
    lng: 41.828528
  }, { lat: 44.768152, lng: 41.828456 }, { lat: 44.768176, lng: 41.828399 }, {
    lat: 44.768187,
    lng: 41.828332
  }, { lat: 44.76819, lng: 41.828278 }, { lat: 44.768126, lng: 41.827881 }, {
    lat: 44.768089,
    lng: 41.827576
  }, { lat: 44.768101, lng: 41.827316 }, { lat: 44.768137, lng: 41.826948 }, {
    lat: 44.768183,
    lng: 41.826402
  }, { lat: 44.76824, lng: 41.825774 }, { lat: 44.768255, lng: 41.825534 }, {
    lat: 44.768298,
    lng: 41.825328
  }, { lat: 44.768336, lng: 41.825109 }, { lat: 44.768424, lng: 41.824614 }, {
    lat: 44.768454,
    lng: 41.824016
  }, { lat: 44.76847, lng: 41.823675 }, { lat: 44.768466, lng: 41.823527 }, {
    lat: 44.768466,
    lng: 41.823437
  }, { lat: 44.768494, lng: 41.823355 }, { lat: 44.768577, lng: 41.823279 }, {
    lat: 44.768688,
    lng: 41.823218
  }, { lat: 44.768835, lng: 41.823098 }, { lat: 44.768983, lng: 41.822978 }, {
    lat: 44.769107,
    lng: 41.822878
  }, { lat: 44.7692, lng: 41.822779 }, { lat: 44.769329, lng: 41.822617 }, {
    lat: 44.769426,
    lng: 41.822477
  }, { lat: 44.769601, lng: 41.822267 }, { lat: 44.769888, lng: 41.821835 }, {
    lat: 44.770225,
    lng: 41.821333
  }, { lat: 44.770415, lng: 41.821045 }, { lat: 44.770623, lng: 41.820729 }, {
    lat: 44.770826,
    lng: 41.820375
  }, { lat: 44.770937, lng: 41.820128 }, { lat: 44.771021, lng: 41.819918 }, {
    lat: 44.771077,
    lng: 41.819716
  }, { lat: 44.771114, lng: 41.819588 }, { lat: 44.771124, lng: 41.819434 }, {
    lat: 44.771124,
    lng: 41.819269
  }, { lat: 44.771111, lng: 41.81911 }, { lat: 44.771089, lng: 41.818883 }, {
    lat: 44.771044,
    lng: 41.818536
  }, { lat: 44.771004, lng: 41.818257 }, { lat: 44.770959, lng: 41.817848 }, {
    lat: 44.770919,
    lng: 41.817587
  }, { lat: 44.770911, lng: 41.817267 }, { lat: 44.770935, lng: 41.81702 }, {
    lat: 44.770954,
    lng: 41.816765
  }, { lat: 44.771001, lng: 41.816435 }, { lat: 44.771104, lng: 41.815944 }, {
    lat: 44.771207,
    lng: 41.815555
  }, { lat: 44.7713, lng: 41.815146 }, { lat: 44.771347, lng: 41.814961 }, {
    lat: 44.77143,
    lng: 41.814662
  }, { lat: 44.771484, lng: 41.814221 }, { lat: 44.771514, lng: 41.813923 }, {
    lat: 44.77153,
    lng: 41.813608
  }, { lat: 44.771494, lng: 41.813277 }, { lat: 44.771445, lng: 41.812641 }, {
    lat: 44.771374,
    lng: 41.811757
  }, { lat: 44.771267, lng: 41.810773 }, { lat: 44.771196, lng: 41.809956 }, {
    lat: 44.771082,
    lng: 41.808812
  }, { lat: 44.771011, lng: 41.808116 }, { lat: 44.770941, lng: 41.807071 }, {
    lat: 44.770847,
    lng: 41.806242
  }, { lat: 44.770806, lng: 41.805447 }, { lat: 44.770729, lng: 41.804402 }, {
    lat: 44.77057,
    lng: 41.803441
  }, { lat: 44.770521, lng: 41.802651 }, { lat: 44.77045, lng: 41.801689 }, {
    lat: 44.770301,
    lng: 41.800125
  }, { lat: 44.770246, lng: 41.798866 }, { lat: 44.770175, lng: 41.79802 }, {
    lat: 44.770061,
    lng: 41.796998
  }, { lat: 44.770005, lng: 41.795987 }, { lat: 44.769898, lng: 41.794953 }, {
    lat: 44.769792,
    lng: 41.793727
  }, { lat: 44.7697, lng: 41.792644 }, { lat: 44.769586, lng: 41.791433 }, {
    lat: 44.769481,
    lng: 41.789848
  }, { lat: 44.769396, lng: 41.788903 }, { lat: 44.769347, lng: 41.78809 }, {
    lat: 44.769311,
    lng: 41.787936
  }, { lat: 44.769247, lng: 41.787789 }, { lat: 44.769106, lng: 41.78766 }, {
    lat: 44.768862,
    lng: 41.787527
  }, { lat: 44.768599, lng: 41.787471 }, { lat: 44.767582, lng: 41.787465 }, {
    lat: 44.766773,
    lng: 41.787482
  }, { lat: 44.765732, lng: 41.787475 }, { lat: 44.765518, lng: 41.787447 }, {
    lat: 44.765407,
    lng: 41.78741
  }, { lat: 44.765328, lng: 41.787309 }, { lat: 44.765304, lng: 41.787203 }, {
    lat: 44.765304,
    lng: 41.787112
  }, { lat: 44.765366, lng: 41.787011 }, { lat: 44.765428, lng: 41.786956 }, {
    lat: 44.765532,
    lng: 41.786906
  }, { lat: 44.765826, lng: 41.786861 }, { lat: 44.766335, lng: 41.78682 }, {
    lat: 44.766831,
    lng: 41.786821
  }, { lat: 44.76729, lng: 41.786887 }, { lat: 44.767559, lng: 41.786956 }, {
    lat: 44.767908,
    lng: 41.787012
  }, { lat: 44.768245, lng: 41.78704 }, { lat: 44.768698, lng: 41.787041 }, {
    lat: 44.769084,
    lng: 41.787028
  }, { lat: 44.769709, lng: 41.787015 }, { lat: 44.770064, lng: 41.787002 }, {
    lat: 44.770536,
    lng: 41.786976
  }, { lat: 44.770892, lng: 41.78693 }, { lat: 44.771333, lng: 41.786872 }, {
    lat: 44.771866,
    lng: 41.78679
  }, { lat: 44.772399, lng: 41.786732 }, { lat: 44.772632, lng: 41.786723 }, {
    lat: 44.775541,
    lng: 41.78678
  }, { lat: 44.777653, lng: 41.786794 }, { lat: 44.778, lng: 41.786798 }, {
    lat: 44.77834,
    lng: 41.786786
  }, { lat: 44.778589, lng: 41.786783 }, { lat: 44.778847, lng: 41.786767 }, {
    lat: 44.779044,
    lng: 41.786742
  }, { lat: 44.779247, lng: 41.78662 }, { lat: 44.779462, lng: 41.78646 }, {
    lat: 44.77969,
    lng: 41.786277
  }, { lat: 44.780121, lng: 41.785953 }, { lat: 44.780577, lng: 41.785556 }, {
    lat: 44.78078,
    lng: 41.785315
  }, { lat: 44.780922, lng: 41.785138 }, { lat: 44.781151, lng: 41.784814 }, {
    lat: 44.781229,
    lng: 41.784689
  }, { lat: 44.781308, lng: 41.784507 }, { lat: 44.781514, lng: 41.783973 }, {
    lat: 44.781725,
    lng: 41.783426
  }, { lat: 44.782085, lng: 41.782523 }, { lat: 44.782308, lng: 41.78203 }, {
    lat: 44.782623,
    lng: 41.781466
  }, { lat: 44.782683, lng: 41.781316 }, { lat: 44.782716, lng: 41.781226 }, {
    lat: 44.782736,
    lng: 41.781148
  }, { lat: 44.782752, lng: 41.781058 }, { lat: 44.782765, lng: 41.780953 }, {
    lat: 44.782811,
    lng: 41.780634
  }, { lat: 44.782789, lng: 41.780488 }, { lat: 44.782759, lng: 41.780401 }, {
    lat: 44.782712,
    lng: 41.78032
  }, { lat: 44.782635, lng: 41.78015 }, { lat: 44.782516, lng: 41.779947 }, {
    lat: 44.782332,
    lng: 41.77968
  }, { lat: 44.782114, lng: 41.779316 }, { lat: 44.781816, lng: 41.778817 }, {
    lat: 44.781747,
    lng: 41.778692
  }, { lat: 44.781709, lng: 41.778589 }, { lat: 44.781662, lng: 41.778422 }, {
    lat: 44.781594,
    lng: 41.778213
  }, { lat: 44.781487, lng: 41.777742 }, { lat: 44.781353, lng: 41.777162 }, {
    lat: 44.781082,
    lng: 41.775997
  }, { lat: 44.780918, lng: 41.775224 }, { lat: 44.780815, lng: 41.774929 }, {
    lat: 44.779934,
    lng: 41.773104
  }, { lat: 44.779523, lng: 41.772289 }, { lat: 44.779429, lng: 41.772114 }, {
    lat: 44.779353,
    lng: 41.771908
  }, { lat: 44.779261, lng: 41.771601 }, { lat: 44.779205, lng: 41.771384 }, {
    lat: 44.779154,
    lng: 41.771102
  }, { lat: 44.779125, lng: 41.770573 }, { lat: 44.779125, lng: 41.770257 }, {
    lat: 44.779154,
    lng: 41.769963
  }, { lat: 44.779223, lng: 41.769528 }, { lat: 44.779285, lng: 41.76933 }, {
    lat: 44.779487,
    lng: 41.76875
  }, { lat: 44.779997, lng: 41.767584 }, { lat: 44.780134, lng: 41.767158 }, {
    lat: 44.780211,
    lng: 41.766667
  }, { lat: 44.780199, lng: 41.766111 }, { lat: 44.780206, lng: 41.764185 }, {
    lat: 44.780198,
    lng: 41.762791
  }, { lat: 44.780215, lng: 41.76138 }, { lat: 44.780226, lng: 41.760481 }, {
    lat: 44.780224,
    lng: 41.759923
  }, { lat: 44.780202, lng: 41.759205 }, { lat: 44.780139, lng: 41.758796 }, {
    lat: 44.780076,
    lng: 41.758504
  }, { lat: 44.780025, lng: 41.758267 }, { lat: 44.779914, lng: 41.757882 }, {
    lat: 44.779583,
    lng: 41.757248
  }, { lat: 44.779435, lng: 41.756983 }, { lat: 44.779228, lng: 41.75667 }, {
    lat: 44.779077,
    lng: 41.756128
  }, { lat: 44.779006, lng: 41.75597 }, { lat: 44.778902, lng: 41.755684 }, {
    lat: 44.777717,
    lng: 41.753853
  }, { lat: 44.777641, lng: 41.753741 }, { lat: 44.777581, lng: 41.753657 }, {
    lat: 44.777477,
    lng: 41.753567
  }, { lat: 44.777309, lng: 41.753485 }, { lat: 44.777058, lng: 41.753332 }, {
    lat: 44.77617,
    lng: 41.752836
  }, { lat: 44.775561, lng: 41.752407 }, { lat: 44.775332, lng: 41.752268 }, {
    lat: 44.775259,
    lng: 41.752241
  }, { lat: 44.775211, lng: 41.752238 }, { lat: 44.775167, lng: 41.752249 }, {
    lat: 44.775151,
    lng: 41.75227
  }, { lat: 44.775149, lng: 41.75234 }, { lat: 44.775277, lng: 41.752944 }, {
    lat: 44.775368,
    lng: 41.753273
  }, { lat: 44.775479, lng: 41.753485 }, { lat: 44.775621, lng: 41.753687 }, {
    lat: 44.775792,
    lng: 41.753877
  }, { lat: 44.775989, lng: 41.754051 }, { lat: 44.776032, lng: 41.754063 }, {
    lat: 44.776115,
    lng: 41.754082
  }, { lat: 44.776196, lng: 41.754092 }, { lat: 44.776233, lng: 41.754095 }, {
    lat: 44.776327,
    lng: 41.754097
  }, { lat: 44.77642, lng: 41.754092 }, { lat: 44.776513, lng: 41.754079 }, {
    lat: 44.776581,
    lng: 41.754065
  }, { lat: 44.777193, lng: 41.753485 }, { lat: 44.777342, lng: 41.753371 }, {
    lat: 44.77803,
    lng: 41.75264
  }, { lat: 44.778091, lng: 41.752553 }, { lat: 44.778125, lng: 41.752469 }, {
    lat: 44.778185,
    lng: 41.752281
  }, { lat: 44.778185, lng: 41.752277 }, { lat: 44.778184, lng: 41.752155 }, {
    lat: 44.778183,
    lng: 41.752086
  }, { lat: 44.778125, lng: 41.751909 }, { lat: 44.777994, lng: 41.751704 }, {
    lat: 44.777711,
    lng: 41.751239
  }, { lat: 44.777322, lng: 41.750515 }, { lat: 44.777186, lng: 41.750227 }, {
    lat: 44.777109,
    lng: 41.749967
  }, { lat: 44.777081, lng: 41.749741 }, { lat: 44.777087, lng: 41.749514 }, {
    lat: 44.77716,
    lng: 41.749144
  }, { lat: 44.777188, lng: 41.749096 }, { lat: 44.777208, lng: 41.749069 }, {
    lat: 44.777248,
    lng: 41.749036
  }, { lat: 44.777296, lng: 41.749018 }, { lat: 44.777373, lng: 41.749012 }, {
    lat: 44.777449,
    lng: 41.749009
  }, { lat: 44.777545, lng: 41.749037 }, { lat: 44.77782, lng: 41.749206 }, {
    lat: 44.777939,
    lng: 41.749316
  }, { lat: 44.778033, lng: 41.749371 }, { lat: 44.778117, lng: 41.749404 }, {
    lat: 44.778219,
    lng: 41.749428
  }, { lat: 44.778634, lng: 41.749484 } ]
export default bus
